import { AppState } from 'store/root.reducer'
import { isBellNotification, isChatNotification } from 'types/notifications'

export const selectNotificationsState = (state: AppState) => state?.notifications

/** Full unified inbox (chat + status + document). */
export const selectNotifications = (state: AppState) => selectNotificationsState(state)?.notifications

/** Chat unread only — order-row message badges. */
export const selectChatNotifications = (state: AppState) => (selectNotifications(state) || []).filter(isChatNotification)

/** Bell dropdown / tab badge — chat + document upload. */
export const selectBellNotifications = (state: AppState) => (selectNotifications(state) || []).filter(isBellNotification)
